<template>
  <div style="width: 1200px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="联系我们" name="first" style="text-align: left;padding: 10px">
        <div style="float: left;padding-left: 50px;margin-bottom: 10px">
          <!-- <div style="font-size: 18px;font-weight: bold;">姓名:{{name}}</div> -->
          <div style="font-size: 18px;font-weight: bold;padding-top: 20px">电话:{{mobile}}</div>
          <!-- <div style="font-size: 18px;font-weight: bold;padding-top: 20px">手机:{{phone}}</div> -->
          <div style="font-size: 18px;font-weight: bold;padding-top: 20px">E-mail:{{mail}}</div>
          <div style="font-size: 18px;font-weight: bold;padding-top: 20px">地址:{{address}}</div>
        </div>
        <div style="float: right;">
          <div id="container"></div>
          <!-- <img :src="imgurl"> -->
        </div>
       </el-tab-pane>
      <el-tab-pane label="信息留言" name="second">
        <div style="width: 500px;margin: 0 auto">
        <el-form ref="form" :model="form" >
          <el-form-item label="姓名" label-width="80px">
            <el-input v-model="form.name" ></el-input>
          </el-form-item>
          <el-form-item label="电话" label-width="80px">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="内容" label-width="80px">
            <el-input type="textarea" v-model="form.desc" style="width: 300px;float: left"></el-input>
          </el-form-item>
          <el-form-item style="width: 300px;" label-width="15px">
            <el-button type="primary" @click="onSubmit">留言</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
        </div>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>
<script src="https://map.qq.com/api/gljs?v=1.exp&key=3YPBZ-6Q6KK-I5UJH-AFD3O-JJZFJ-XGB6F"></script>
<script>

import Utils from '../../assets/js/util.js';
// import TMap from "TMap";
export default {
  name: "Contactus",
  data(){
    return{
      map: null,
      tabPosition: 'left',
      activeName: 'first',
      name: '',
      mobile: '',
      phone: '',
      mail: '',
      address: '',
      imgurl:'',
      form: {
        name: '',
        phone: '',
        desc: ''
      }
    }
  },
  mounted(){
    this.loadScript();
    let that=this;
    Utils.$on('demo', function (msg) {
      if(msg == '9-1'){
        that.activeName = "first";
      }else if(msg == '9-2'){
        that.activeName = "second";
      }
    });
    let name = sessionStorage.getItem('currentTab')
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if(name){
      this.activeName = name
    }
  },
  beforeRouteLeave(to, from, next){
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem('currentTab')
    next()
  },
  created() {
    this.contact();

  },
  methods: {
    initMap() {
          //定义地图中心点坐标
          var center = new TMap.LatLng(34.77818,113.65562)
          //定义map变量，调用 TMap.Map() 构造函数创建地图
          var map = new TMap.Map(document.getElementById('container'), {
              center: center,//设置地图中心点坐标
              zoom: 19,   //设置地图缩放级别
              //pitch: 43.5,  //设置俯仰角
             // rotation: 45    //设置地图旋转角度
          });
          //创建并初始化MultiMarker
      var markerLayer = new TMap.MultiMarker({
          map: map,  //指定地图容器
          id: 'marker-layer',
         //样式定义
         styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
           "markerLayer": new TMap.MarkerStyle({
            "width": 25,  // 点标记样式宽度（像素）
            "height": 35, // 点标记样式高度（像素）
            "src": '../../static/images/mark.jpeg',  //图片路径
            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            // "anchor": { x: 16, y: 32 }
            })
         },
         geometries: [{
          "id": 'demo1',
          "styleId": 'markerLayer',
          "position": new TMap.LatLng(34.77818,113.65562),

         }]

        })
    },
        loadScript() {
          var script = document.createElement("script");
          script.type = "text/javascript";
           script.src = "https://map.qq.com/api/gljs?v=1.exp&key=3YPBZ-6Q6KK-I5UJH-AFD3O-JJZFJ-XGB6F";
          script.onload = script.onreadystatechange = () => {
              if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete" ) {
                  this.initMap();
                  script.onload = script.onreadystatechange = null;
              }
          };
          document.body.appendChild(script);
        },

    /*联系我们*/
    contact (){
      let params = {}
      this.axios.post('/api/index/contactList',params).then((response) => {
          if(response.data.msg == 'success'){
            this.name = response.data.data.phone_name
            this.mobile = response.data.data.zj
            this.phone = response.data.data.phone
            this.mail = response.data.data.email
            this.address = response.data.data.addr
            this.imgurl = response.data.data.qr_code
          }
      }).catch(function (error) {
        console.log(error)
      });
    },
    handleClick(tab, event) {
      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      sessionStorage.setItem('currentTab', tab.name)
    },
    //信息留言
    onSubmit() {
      if(this.form.name == ''){
        this.$message.error('姓名不能为空')
        return
      }else if(this.form.phone == ''){
        this.$message.error('电话不能为空')
        return
      }else if(this.form.desc == ''){
        this.$message.error('验证码不能为空')
        return
      }
      let params = {
        phone: this.form.phone,
        message: this.form.desc,
      }
      this.axios.post('/api/index/subMessage',params).then((response) => {
        if(response.data.code == 1){
          this.$message({
            showClose: true,
            type:'success',
            message:'留言成功',
            duration:2000
          })
          this.$router.go(0)
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }
}
</script>

<style scoped>
.xh >>>.el-tabs__nav-wrap::after {
  position: static !important;
}
.xh >>>.el-tabs__active-bar {
  background-color: transparent !important;
}
.el-input {
  width: 150px;
  float: left;
}

    #container{
    /*地图(容器)显示大小*/
    width:600px;
    height:300px;
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/view/Contactus.vue